import axios from "axios"
const BASE_URL = process.env.REACT_APP_API_URL

class CourseApi {
  addCourse(data, config) {
    return axios.post(BASE_URL + "/admin/course/create", data, config)
  }
  getAllCourse(config) {
    return axios.get(BASE_URL + "/admin/course/getCourse", config)
  }

  updateCourse(data, config) {
    return axios.put(BASE_URL + "/admin/course/update", data, config)
  }
  getCourseById(id, config) {
    return axios.get(`${BASE_URL}/admin/course/getCourseById/${id}`, config)
  }
  
  uploadCourseByExcel(data, config) {
    return axios.post(
      BASE_URL + "/admin/course/uploadCourse",
      data,
      config,
    )
  }
  updateCourseStatus(data, config) {
    return axios.put(BASE_URL + "/admin/course/updateStatus", data, config)
  }

  searchCourseAndProgram(data, config) {  
    return axios.get(BASE_URL + "/admin/course/searchCoursesAndPrograms", data, config)
  }
}

export default new CourseApi()
